// extracted by mini-css-extract-plugin
module.exports =  {"pagination":"JdQqC2nW"};